module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "piecewise"
    }
  }, [_c('div', {
    ref: "viewoutBox",
    staticClass: "piecewise",
    style: ('margin-top:' + _vm.playHeight + 'px'),
    attrs: {
      "id": "piecewise"
    }
  }, [_c('ul', {
    ref: "innerBox",
    staticClass: "clearfix",
    class: 'piecewise' + _vm.styleType,
    style: ('width:' + _vm.breakPoints.length * 100 + 'px')
  }, _vm._l((_vm.breakPoints), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: (index == _vm.videoIndex),
        mini: (item.title.length > 6)
      }
    }, [(item.title.length > 6 && item.title.length <= 10) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.switchVideo(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title.substr(0, 5))), _c('br'), _vm._v(_vm._s(item.title.substr(5)))]) : (item.title.length > 10) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.switchVideo(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title.substr(0, 7))), _c('br'), _vm._v(_vm._s(item.title.substr(7)))]) : _c('a', {
      on: {
        "click": function($event) {
          return _vm.switchVideo(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b0693c6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/pieceWise.vue
// module id = 342
// module chunks = 0